const allowedFormat = [
	{ text: '', key: 'text.allowedFormats.jpg', value: 0 },
	{ text: '', key: 'text.allowedFormats.png', value: 1 },
	{ text: '', key: 'text.allowedFormats.html', value: 2 },
	{ text: '', key: 'text.allowedFormats.pdf', value: 3 },
	{ text: '', key: 'text.allowedFormats.doc', value: 4 },
	{ text: '', key: 'text.allowedFormats.xls', value: 5 },
	{ text: '', key: 'text.allowedFormats.txt', value: 6 },
];

function getAllowedFormats(_this) {
	allowedFormat.forEach((x) => {
		if (x.key != null) x.text = _this.$t(x.key);
	});
	return allowedFormat;
}

export default getAllowedFormats;
